// Rosto e nome que abrem o perfil público por cima da tela (bot não tem perfil: quem chama não usa para bot).
import type { ReactNode } from 'react';
import { abrirPerfil } from './perfilAberto.ts';

export function BotaoPerfil({ usuario, apelido, children, className }: { usuario: string; apelido: string; children: ReactNode; className?: string }) {
  return (
    <button type="button" className={'abre-perfil' + (className ? ' ' + className : '')} aria-label={`Ver perfil de ${apelido}`} onClick={() => abrirPerfil(usuario)}>
      {children}
    </button>
  );
}
